module.exports = __webpack_public_path__ + "assets/img/tx112_4.71df188b.jpg";